import {
    Box,
    Button,
    FormControl,
    InputLabel,
    MenuItem,
    Paper,
    Select,
    TextField,
    Typography,
    Switch,
    FormControlLabel,
    Grid,
    Alert,
    Modal,
    CircularProgress,
} from "@mui/material";
import { useEffect, useState } from "react";
import { Edit, Save, Download, Upload, Delete } from "@mui/icons-material";
import { useConfiguracoesPedidoContext } from "../../../../../pedidos/contexts/ConfiguracoesPedidoContext";
import { IConfiguracaoNFCe, RegimeTributarioNfce } from "../../../../../pedidos/interface/IConfiguracaoNFCe";
import { IEndereco } from "../../../../../core/interfaces/IEndereco";
import { useRef } from "react";


export const ConfiguracaoEmissaoNotaFiscal = () => {
    const [edicaoHabilitada, setEdicaoHabilitada] = useState(true);
    const { configuracao, salvarConfiguracaoNFCe, excluirConfiguracaoNFCe, handleRefresh, loading } = useConfiguracoesPedidoContext();

    const inputRef = useRef<HTMLInputElement | null>(null);

    const [form, setForm] = useState<IConfiguracaoNFCe>({
        razaoSocial: "",
        nomeFantasia: "",
        endereco: {
            rua: "",
            numero: "",
            cidade: "",
            cep: "",
            complemento: "",
            bairro: "",
            uf: "",
        },
        cnpj: "",
        inscricaoEstadual: 0,
        regimeTributario: RegimeTributarioNfce["Simples Nacional"],
        csc: "",
        idCsc: "",
        certificado: {
            senha: "",
            conteudo: "",
        },
    });

    const [certificadoNome, setCertificadoNome] = useState<string>("");
    const [certificadoArquivo, setCertificadoArquivo] = useState<File | null>(null);
    const [modalAberta, setModalAberta] = useState(false);
    const [senhaTemporaria, setSenhaTemporaria] = useState<string>("");
    const [arquivoTemporario, setArquivoTemporario] = useState<File | null>(null);
    const [novoCertificadoCarregado, setNovoCertificadoCarregado] = useState(false);

    useEffect(() => {
        if (configuracao?.configuracoesNFCe?.length) {
            setEdicaoHabilitada(false);

            const dados = configuracao.configuracoesNFCe[0];

            setForm({
                ...dados,
                inscricaoEstadual: Number(dados.inscricaoEstadual || 0),
                endereco: {
                    rua: dados.endereco?.rua || "",
                    numero: dados.endereco?.numero || "",
                    cidade: dados.endereco?.cidade || "",
                    cep: dados.endereco?.cep || "",
                    complemento: dados.endereco?.complemento || "",
                    bairro: dados.endereco?.bairro || "",
                    uf: dados.endereco?.uf || "",
                },
                certificado: {
                    senha: dados.certificado?.senha,
                    conteudo: dados.certificado?.conteudo,
                },
            });

            if (dados.certificado?.conteudo) {
                setCertificadoNome("Certificado carregado");
            }

            setNovoCertificadoCarregado(false);
        }
    }, [configuracao]);

    const handleChange = (field: keyof IConfiguracaoNFCe, value: any) => {
        setForm((prev) => ({ ...prev, [field]: value }));
    };

    const handleEnderecoChange = (field: keyof IEndereco, value: string) => {
        setForm((prev) => ({
            ...prev,
            endereco: { ...prev.endereco, [field]: value },
        }));
    };

    const processarCertificado = () => {
        if (!arquivoTemporario || !senhaTemporaria) return;

        const reader = new FileReader();
        reader.onload = () => {
            const base64 = (reader.result as string).split(",")[1];

            setForm(prev => ({
                ...prev,
                certificado: {
                    senha: senhaTemporaria,
                    conteudo: base64,
                },
            }));

            setCertificadoNome(arquivoTemporario.name);
            setCertificadoArquivo(arquivoTemporario);
            setNovoCertificadoCarregado(true);
            limparModal();
        };
        reader.readAsDataURL(arquivoTemporario);
    };



    const handleCertificadoUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (file) {
            setArquivoTemporario(file);
            setModalAberta(true);
        }
    };

    const limparModal = () => {
        setModalAberta(false);
        setSenhaTemporaria("");
        setArquivoTemporario(null);
        inputRef.current!.value = "";
    };

    const handleSalvar = async () => {
        if (!edicaoHabilitada) {
            return setEdicaoHabilitada(true);
        }

        const resultado = await salvarConfiguracaoNFCe(form);
        if (resultado) {
            setEdicaoHabilitada(false);
            setTimeout(() => handleRefresh(), 1000);
        }
    }

    const handleExcluir = async () => {
        if(!form?.uuid) return;

        const resultado = await excluirConfiguracaoNFCe(form?.uuid);
        if (resultado) {
            window.location.reload()
        }
    }

    return (
        <>
            <Modal open={modalAberta} onClose={limparModal}>
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        bgcolor: "background.paper",
                        borderRadius: 2,
                        boxShadow: 24,
                        p: 4,
                        width: 400,
                    }}
                >
                    <Typography variant="h6" mb={2}>Informe a senha do certificado</Typography>
                    <TextField
                        type="password"
                        label="Senha"
                        fullWidth
                        value={senhaTemporaria}
                        onChange={(e) => setSenhaTemporaria(e.target.value)}
                    />
                    <Box display="flex" justifyContent="flex-end" mt={3} gap={2}>
                        <Button variant="outlined" onClick={limparModal}>
                            Cancelar
                        </Button>
                        <Button variant="contained" onClick={processarCertificado} disabled={!senhaTemporaria}>
                            Confirmar
                        </Button>
                    </Box>
                </Box>
            </Modal>

            <Paper sx={{ width: '100%', maxWidth: 1200, mt: 4, p: { xs: 2, sm: 4 } }}>
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: 'center' }}>
                    <Typography variant="h6">Dados fiscais</Typography>
                    {loading ? (
                        <CircularProgress size={25} />
                    ) : (
                        <Box sx={{ display: "flex", gap: '1rem', alignItems: 'center' }}>
                            {form?.uuid && (
                                <Button
                                    onClick={handleExcluir}
                                    variant={"text"}
                                    endIcon={<Delete />}
                                    color="error"
                                >
                                    Excluir
                                </Button>
                            )}
                            <Button
                                onClick={handleSalvar}
                                variant={edicaoHabilitada ? "contained" : "text"}
                                endIcon={edicaoHabilitada ? <Save /> : <Edit />}
                            >
                                {edicaoHabilitada ? "Salvar" : "Editar"}
                            </Button>
                        </Box>
                    )}
                </Box>

                <Grid container spacing={2} mt={1}>
                    {/* Empresa */}
                    <Grid item xs={12}>
                        <Typography variant="subtitle1">Empresa</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField label="Razão Social*" value={form.razaoSocial} onChange={(e) => handleChange("razaoSocial", e.target.value)} disabled={!edicaoHabilitada} fullWidth />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField label="Nome Fantasia*" value={form.nomeFantasia} onChange={(e) => handleChange("nomeFantasia", e.target.value)} disabled={!edicaoHabilitada} fullWidth />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <TextField label="CNPJ*" value={form.cnpj} onChange={(e) => handleChange("cnpj", e.target.value)} disabled={!edicaoHabilitada} fullWidth />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <TextField label="Inscrição Estadual*" value={form.inscricaoEstadual} onChange={(e) => handleChange("inscricaoEstadual", e.target.value)} disabled={!edicaoHabilitada} fullWidth />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <TextField label="Inscrição Municipal" value={form.inscricaoMunicipal ?? ""} onChange={(e) => handleChange("inscricaoMunicipal", e.target.value)} disabled={!edicaoHabilitada} fullWidth />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField label="Telefone" value={form.telefone ?? ""} onChange={(e) => handleChange("telefone", e.target.value)} disabled={!edicaoHabilitada} fullWidth />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField label="E-mail" value={form.email ?? ""} onChange={(e) => handleChange("email", e.target.value)} disabled={!edicaoHabilitada} fullWidth />
                    </Grid>

                    {/* Endereço */}
                    <Grid item xs={12} mt={2}>
                        <Typography variant="subtitle1">Endereço</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField label="Rua*" value={form.endereco.rua} onChange={(e) => handleEnderecoChange("rua", e.target.value)} disabled={!edicaoHabilitada} fullWidth />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <TextField label="Número*" value={form.endereco.numero} onChange={(e) => handleEnderecoChange("numero", e.target.value)} disabled={!edicaoHabilitada} fullWidth />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <TextField label="Complemento" value={form.endereco.complemento} onChange={(e) => handleEnderecoChange("complemento", e.target.value)} disabled={!edicaoHabilitada} fullWidth />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <TextField label="Bairro*" value={form.endereco.bairro} onChange={(e) => handleEnderecoChange("bairro", e.target.value)} disabled={!edicaoHabilitada} fullWidth />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <TextField label="Cidade*" value={form.endereco.cidade} onChange={(e) => handleEnderecoChange("cidade", e.target.value)} disabled={!edicaoHabilitada} fullWidth />
                    </Grid>
                    <Grid item xs={12} sm={2}>
                        <TextField label="CEP*" value={form.endereco.cep} onChange={(e) => handleEnderecoChange("cep", e.target.value)} disabled={!edicaoHabilitada} fullWidth />
                    </Grid>
                    <Grid item xs={12} sm={2}>
                        <TextField label="UF*" value={form.endereco.uf} onChange={(e) => handleEnderecoChange("uf", e.target.value)} disabled={!edicaoHabilitada} fullWidth />
                    </Grid>

                    {/* Configurações fiscais */}
                    <Grid item xs={12} mt={2}>
                        <Typography variant="subtitle1">Configurações fiscais</Typography>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <TextField label="Série NFC-e*" value={form.serie ?? ""} onChange={(e) => handleChange("serie", e.target.value)} disabled={!edicaoHabilitada} fullWidth />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <TextField label="Próximo número NFC-e*" value={form.proximoNumero ?? ""} onChange={(e) => handleChange("proximoNumero", e.target.value)} disabled={!edicaoHabilitada} fullWidth />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <TextField label="Série NF-e" value={form.serieNfe ?? ""} onChange={(e) => handleChange("serieNfe", e.target.value)} disabled={!edicaoHabilitada} fullWidth />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <TextField label="Próximo número NF-e" value={form.proximoNumeroNfe ?? ""} onChange={(e) => handleChange("proximoNumeroNfe", e.target.value)} disabled={!edicaoHabilitada} fullWidth />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            label="Natureza da operação (NF-e)"
                            value={form.naturezaOperacaoNfe ?? ""}
                            onChange={(e) => handleChange("naturezaOperacaoNfe", e.target.value)}
                            disabled={!edicaoHabilitada}
                            placeholder="VENDA DE MERCADORIAS"
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormControl fullWidth>
                            <InputLabel id="regime-label">Regime Tributário*</InputLabel>
                            <Select
                                labelId="regime-label"
                                value={form.regimeTributario}
                                onChange={(e) => handleChange("regimeTributario", e.target.value)}
                                disabled={!edicaoHabilitada}
                                label="Regime Tributário*"
                            >
                                <MenuItem value={1}>Simples Nacional</MenuItem>
                                <MenuItem value={2}>Simples Nacional - Excesso Sublimite</MenuItem>
                                <MenuItem value={3}>Regime Normal</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField label="CSC*" value={form.csc} onChange={(e) => handleChange("csc", e.target.value)} disabled={!edicaoHabilitada} fullWidth />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField label="ID CSC*" value={form.idCsc} onChange={(e) => handleChange("idCsc", e.target.value)} disabled={!edicaoHabilitada} fullWidth />
                    </Grid>
                    <Grid item xs={12}>
                        <Button endIcon={<Upload />} component="label" disabled={!edicaoHabilitada} variant="outlined">
                            {certificadoNome ? "Atualizar certificado" : "Upload Certificado Digital (.pfx)"}
                            <input ref={inputRef} type="file" accept=".pfx" hidden onChange={handleCertificadoUpload} />
                        </Button>
                    </Grid>

                    {!novoCertificadoCarregado && certificadoNome && (
                        <Grid item xs={12}>
                            <Alert severity="info">
                                Um certificado já está carregado. Você pode atualizá-lo fazendo o upload de um novo.
                            </Alert>
                        </Grid>
                    )}

                    {novoCertificadoCarregado && (
                        <Grid item xs={12}>
                            <Alert severity="success">
                                Novo certificado carregado com sucesso. Basta salvar para confirmar as alterações.
                            </Alert>
                        </Grid>
                    )}


                    <Grid item xs={12} sm={6}>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={form.discriminaImpostos ?? false}
                                    onChange={(e) => handleChange("discriminaImpostos", e.target.checked)}
                                    disabled={!edicaoHabilitada}
                                />
                            }
                            label="Discriminar impostos na nota"
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={form.enviarEmailDestinatario ?? false}
                                    onChange={(e) => handleChange("enviarEmailDestinatario", e.target.checked)}
                                    disabled={!edicaoHabilitada}
                                />
                            }
                            label="Enviar nota por e-mail ao destinatário"
                        />
                    </Grid>
                </Grid>
            </Paper>
        </>
    );
}